import React from "react";
var __jsx = React.createElement;
import stl from "@/pages/post/components/carReportSection/CarReportSection.module.css";
import { useState } from "react";
import CarReportDisclaimerPopUp from "@/pages/post/components/carReportSection/CarReportDisclaimerPopUp";
import { useTranslation } from "@i18n";
var DateSection = function DateSection(_ref) {
  var isTrackingView = _ref.isTrackingView,
    inspection = _ref.inspection;
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  var _useState = useState(false),
    showDisclaimerPopUp = _useState[0],
    setShowDisclaimerPopUp = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.dateContainer
  }, !isTrackingView && /*#__PURE__*/React.createElement("div", null), isTrackingView && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: stl.date
  }, /*#__PURE__*/React.createElement("label", null, t("تاريخ الفحص:", {
    ns: "web_post_view"
  })), inspection === null || inspection === void 0 ? void 0 : inspection.report_date)), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowDisclaimerPopUp(true);
    }
  }, t("إخلاء مسؤولية", {
    ns: "web_post_view"
  }))), showDisclaimerPopUp && /*#__PURE__*/React.createElement(CarReportDisclaimerPopUp, {
    onClose: function onClose() {
      return setShowDisclaimerPopUp(false);
    }
  }));
};
export default DateSection;